





















import { Component, Watch } from "vue-property-decorator";
import CHeader from "@/components/CHeader.vue";
import CFooter from "@/components/CFooter.vue";
import RTab from "@/components/RTab.vue";
import ROrderEditForm from "@/components/forms/ROrderEditForm.vue";
import CheckRestaurantLogin from "@/utils/CheckRestaurantLogin";
import AuthModule from "@/store/auth";
import OrderModule from "@/store/order";
import RestaurantModule from "@/store/restaurant";
import { OrdersApi, RestaurantsApi } from "@/services/api-service";

@Component({
  components: {
    CHeader,
    CFooter,
    RTab,
    ROrderEditForm,
  },
})
export default class REditOrder extends CheckRestaurantLogin {
  private get me() {
    return AuthModule.me;
  }

  private mounted() {
    OrderModule.commitNewOrders([]);
    this.getOrder();
    this.getMenus();
  }

  private async getOrder() {
    if (this.$route.params?.uuid) {
      return;
    }
    // eslint-disable-next-line prettier/prettier
    const orderRes = await OrdersApi.instance.getOrder(this.$route.params.uuid);
    const order = orderRes.data?.data?.order;
    if (!order) {
      return;
    }
    OrderModule.commitOrder(order);
  }

  @Watch("me")
  private async getMenus() {
    if (!this.me?.uuid) {
      return;
    }
    // eslint-disable-next-line prettier/prettier
    const menusRes = await RestaurantsApi.instance.getMenusByRestaurantUuid(this.me.uuid, undefined, undefined, true);
    const menus = menusRes.data?.data?.items;
    if (!menus) {
      return;
    }
    RestaurantModule.commitMenus(menus);
  }
}
